<template>
    <!-- Модальне вікно додавання клієнта в обрані -->

    <dialogBox>
        <template v-slot:title>{{ $t('Додати тікет до обраних') }}</template>
        <template v-slot:body>

            <!-- Рівень адекватності -->
            <div class="mb-3">
                <h4 class="fs-15">{{ $t('Вкажіть пріоритет відслідковування') }}</h4>
                <b-form-select v-model="form.priority" :options="listAdequacy" :disabled="!form.onlyView"></b-form-select>
            </div>

            <!-- Коментар -->
            <div class="mb-3">
                <h4 class="fs-15">{{ $t('Вкажіть коментарі') }}</h4>
                <div class="flex-grow-1 mb-2">
                    <div class="input-group" v-if="form.onlyView == false">
                        <input type="text" v-model="comment.commentText" @keydown.enter="addComment(comment)" class="form-control"  >
                        <button @click="addComment(comment)" class="btn btn-success" type="button" ><i class="ri-add-line"></i></button>
                    </div>
                    <ul class="list-unstyled vstack gap-3 mb-0 mt-3">
                        <li v-for="(input, index) in this.form.comments" :key="index">
                            <div class="d-flex align-items-center">
                                <div class="flex-shrink-0">
                                    <div class="avatar-xs flex-shrink-0 me-1">
                                        <div class="avatar-title rounded bg-light text-black">#{{index+1}}</div>
                                    </div>
                                </div>
                                <div class="flex-grow-1 ms-2">
                                    <div class="input-group">
                                        <input type="text" :disabled="!form.onlyView" class="form-control" v-model="input.comment" @keydown.enter="addComment(input,index)">
                                        <button @click="addComment(input,index)" :disabled="!form.onlyView" class="btn btn-success" type="button"><i class="ri-add-line"></i></button>
                                        <button @click="removeComment(index)" :disabled="!form.onlyView" class="btn btn-danger" type="button"><i class="ri-delete-bin-2-line"></i></button>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </template>
        <template v-slot:footer-bottom>
            <div class="hstack gap-2 mt-3 justify-content-center remove">
                <!-- Кнопка для закриття модального вікна -->
                <button class="btn btn-danger" @click="$emit('close')">{{ $t('cancel') }}</button>

                <!-- Кнопка додати/зберегти -->
                <button v-if="form.onlyView == false" class="btn btn-success" @click="this.objForm.permEdit == true ? save() : addFavorite()">{{ this.objForm.permEdit == true ? $t('save') : $t('Add') }}</button>
            </div>
        </template>
    </dialogBox>

</template>

<script>
import dialogBox from '@/components/modal/dialog' // компонент модального вікна

export default{
    props: ['obj','objForm'],
    components: {
        dialogBox
    },
    data(){
        return{
            form: {
                ticketId: '',
                priority: 1,
                comments: []
            },
            objCard: {},
            listAdequacy: [
                { value: 3, text: this.$t('priorityHigh') }, // високий
                { value: 2, text: this.$t('priorityMedium') }, // середній
                { value: 1, text: this.$t('priorityLow') }, // низький
            ],
            accounts: [], // акаунти
            comment: {
                commentText: ""
            },
        }
    },
    created(){
        console.log("this", this);

        // this.objCard = this.obj

        // редагуємо картку
        if(this.objForm != undefined) {
            // this.form = this.objForm.obj
            this.form = {
                ticketId: this.objForm.obj.ticketId || 1,
                priority: this.objForm.obj.priority || 1,
                comments: this.objForm.obj.comments || []
            };
        }

        this.accounts = JSON.parse(localStorage.getItem('favoriteAccounts')) || [];
    },
    methods: {
        addComment(e, index) {
            
            // Якщо індекс переданий (натиснуто "+", в конкретному пункті списку)
            if (index !== undefined) {
                // Додаємо порожній елемент після поточного індексу
                this.form.comments.splice(index + 1, 0, {
                    commentText: '', // Порожнє завдання
                });
            } else {
                // Якщо індекс не переданий (натиснуто "+", в полі вводу нового пункту)
                this.form.comments.push({
                    comment: e.commentText, // Додаємо в кінець зі значенням
                });
                this.comment.commentText = ''; // Очищаємо поле вводу
            }
        },
        removeComment(index){
            this.form.comments.splice(index, 1);
        },
        addFavorite(){
            // Додаємо тікет в обрані

            console.log(this.objCard);
            let tickets = JSON.parse(localStorage.getItem('favoriteTickets')) || [];
            
            // тікет, дати, коментарі, тип, пріоритет
            let newTicket = {
                "ticketId": this.objCard.ticketId,
                "type": 'ticket',
                "date": this.currentDate(),
                "priority": this.form.priority,
                "comments": this.form.comments,
            };

            // Перевірка, чи існує тікет в масиві
            let existingTicket = tickets.find(acc => acc.ticketId === newTicket.ticketId);

            if (!existingTicket) {
                tickets.push(newTicket);
                localStorage.setItem('favoriteTickets', JSON.stringify(tickets));
                this.checkFavorite = true
                this.$toast.success("numberAddedtoFavorites")
                this.$emit('close')
                this.$emit('changeFav')
            } else {
                console.log('Account already exists in the favorites.');
                this.$toast.error(this.$t('"AccountAlreadyExistsFavorites"'))
            }
        },
        save(){
            // Редагуваємо картку 
            console.log("ths save > ", this);
            

            let tickets = JSON.parse(localStorage.getItem('favoriteTickets')) || [];
    
            let updatedTicket = {
                "ticketId": this.objForm.obj.ticketId,
                "type": 'ticket',
                "date": this.currentDate(),
                "priority": this.form.priority,
                "comments": this.form.comments,
            };

            console.log("updatedTicket", updatedTicket);

            // Пошук індексу обраного тікету за ticketId
            let indexToUpdate = tickets.findIndex(item => item.ticketId === updatedTicket.ticketId);
            console.log("tickets >", tickets);
            console.log("updatedTicket >", updatedTicket);
            console.log("indexToUpdate >", indexToUpdate);
            

            if (indexToUpdate !== -1) {
                // Заміна акаунта за індексом
                tickets[indexToUpdate] = updatedTicket;
                localStorage.setItem('favoriteTickets', JSON.stringify(tickets));
                this.$toast.success("Оновлено");
                this.$emit('close');
            } else {
                console.log('Account not found in the favorites.');
                this.$toast.error(this.$t('AccountNotInFavorites'));
            }
        },
        currentDate() {
            var date = new Date();
            var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + (date.getDate())).slice(-2) + " " +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2);
            return dateStr
        },
    }
}
</script>